import { Button, withStyles } from "@material-ui/core";

export const colorButtonStyles = (theme) => ({
	root: {
		color: "#ffffff",
		borderRadius: 25.5,
		width: 150,
		height: 44,
		fontSize: 12,
		position: "flex",
		backgroundColor: "#630094",
		textTransform: "none",
		"&:hover": {
			backgroundColor: "#7c00B9",
		},
	},
});

const ColorButton = withStyles(colorButtonStyles)(Button);

export default ColorButton;
